export default __webpack_public_path__ + "static/media/language.4792acdd.svg";